// helpers
import configureStore from '@utils/configureReduxStore';

// Root Reducer, Actions and Sagas
import rootReducer from './reducers';
import rootSaga from './sagas';

const store = configureStore({
  reducer: rootReducer,
  sagaActionWatcher: rootSaga,
});

export type GlobalStore = ReturnType<typeof store.getState>;

export default store;
